module.exports = __webpack_public_path__ + "static/media/swimming-pool-color.330c11d0.svg";